import { z } from "zod";

import { COGNITO_ADMIN_GROUP, COGNITO_AUTOMATION_GROUP } from "@recobra/core";

const TaskReminderStatus = z.enum(["pending", "sent", "not_sent", "canceled"]);
export type TaskReminderStatus = z.infer<typeof TaskReminderStatus>;

export const TaskReminderSchema = z.object({
  id: z.uuid().meta({ visibleTo: "*" }),
  scheduledDate: z.iso.date().meta({ visibleTo: "*" }),
  comment: z.string().max(2000).optional().meta({ visibleTo: "*" }),
  status: TaskReminderStatus.meta({ visibleTo: "*" }),
  createdBy: z.string().min(1).meta({ visibleTo: "*" }),
  createdAt: z.iso.datetime().meta({ visibleTo: "*" }),
  processedAt: z.iso.datetime().optional().meta({ visibleTo: "*" }),
  dedupeKey: z
    .string()
    .max(200)
    .optional()
    .meta({ visibleTo: [COGNITO_ADMIN_GROUP, COGNITO_AUTOMATION_GROUP] }),
});
export type TaskReminder = z.infer<typeof TaskReminderSchema>;

export const CreateTaskReminderSchema = z.object({
  scheduledDate: z.iso.date(),
  comment: z.string().trim().max(2000).optional(),
  dedupeKey: z.string().trim().max(200).optional(),
});
export type CreateTaskReminderInput = z.infer<typeof CreateTaskReminderSchema>;

export const UpdateTaskReminderSchema = CreateTaskReminderSchema.omit({ dedupeKey: true });
export type UpdateTaskReminderInput = z.infer<typeof UpdateTaskReminderSchema>;
